import { routeStoreLenses } from 'root/src/client/logic/route/lenses'

const { pathOrVariantRouteIndex } = routeStoreLenses

export default pathOrVariantRouteIndex(0)
